import React from "react";
import { useLocation } from "react-router-dom";
import BgpTabs from "../components/Tabs/BGP/BgpTabs";
import InstancesTabs from "../components/Tabs/Instances/InstancesTabs";
import L3OverviewTabs from "../components/Tabs/L3Overview/L3OverviewTabs";
import AddServiceTabs from "../components/Tabs/AddService/AddService";
import PortDetailsTabs from "../components/Tabs/PortDetails/PortDetails";
import { useAppSelector } from "@redux/hooks";
import { RootState } from "@redux/store/store";
import ConnectionDetailsTabs from "../components/Tabs/ConnectionDetails/ConnectionDetails";
import ReflectorsTabs from "../components/Tabs/ReflectorV2/Reflectors/ReflectorsTabs";
import CloudDetailsTabs from "../components/Tabs/CloudDetails/CloudDetails";
import DatacenterDetailsTabs from "../components/Tabs/DatacenterDetails/DatacenterDetails";
import BackboneDetailsTabs from "../components/Tabs/BackboneDetails/BackboneDetailsTabs";
import TagsManagerFilters from "settings/account/components/TagsManager/TagsManagerFilters";
import NotificationsGroupsFilters from "settings/account/components/NotificationsV2/NotificationsGroupsFilters";
import { trimTrailingSlash } from "@shared/helpers/pathname";

/**
 * Routes whose sub-tabs are a two-option switcher. Those render inside the title row
 * (see `SideNav`), not on a row of their own below it: a segmented control of two
 * words did not earn the header ~50px of height.
 */
export function routeHasInlineTabs(pathname: string): boolean {
    const path = trimTrailingSlash(pathname);
    return (
        path === "/reflector-v2/management/bgp-reflectors" ||
        path === "/reflector-v2/management/clusters" ||
        path === "/reflector-v2/management/licensing" ||
        path === "/reflector-v2/management/licensing/payg"
    );
}

export function InlineRouteTabs() {
    const location = useLocation();
    return routeHasInlineTabs(location.pathname) ? <ReflectorsTabs /> : null;
}

export default function RenderTabsByRoute() {
    const currentStep = useAppSelector((state: RootState) => state.order.currentStep);
    const notificationsAccountTab = useAppSelector(
        (state: RootState) => state.notificationsV2Account.activeTab
    );
    const location = useLocation();
    const isInstancesRoute =
        location.pathname.startsWith("/reflector/management/instances/licensed") ||
        location.pathname.startsWith("/reflector/management/instances/unlicensed") ||
        location.pathname.startsWith("/reflector/management/instances/highavailability") ||
        location.pathname.startsWith("/reflector/management/instances/healthcheck") ||
        location.pathname.startsWith("/reflector/management/instances/syslog");

    return (
        <>
            {location.pathname.startsWith("/kontrol/add-port") &&  currentStep === 4 &&(
                <AddServiceTabs />
            )}
            {location.pathname === "/kontrol/port-details" && <PortDetailsTabs />}
            {location.pathname === "/kontrol/internet/internet-details" && <ConnectionDetailsTabs />}
            {location.pathname === "/kontrol/cloud-connectivity/details" && <CloudDetailsTabs />}
            {location.pathname === "/kontrol/datacenter-details" && <DatacenterDetailsTabs />}
            {location.pathname === "/kontrol/backbone-details" && <BackboneDetailsTabs />}
            {location.pathname === "/account/tags-manager" && <TagsManagerFilters />}
            {location.pathname === "/account/notifications" &&
                notificationsAccountTab === "groups" && <NotificationsGroupsFilters />}

            {location.pathname === "/reflector/management/bgp/neighbors" && <BgpTabs />}
            {location.pathname === "/reflector/management/bgp/status" && <BgpTabs />}

            {location.pathname.startsWith("/reflector/l3overview") && <L3OverviewTabs />}

            {isInstancesRoute && <InstancesTabs />}

            {/* Device/Cluster View and license-type switchers render inline in the
                title row — see `InlineRouteTabs`. */}

        </>
    );
}
